/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, DraggablePositionType } from '@components/atoms'
import { PdfDraggableView } from './PdfDraggableView'

interface PropsType {
	onStop: (e: DraggablePositionType) => void
	onSubmit: (str: string) => any
	onClose: () => void
	initialText: any
}

export const DraggableText = (props: PropsType) => {
	const { onStop, onSubmit, onClose, initialText } = props

	const [text, setText] = React.useState<string>('Text')
	const inputRef = React.useRef<any>(null)

	React.useEffect(() => {
		if (initialText) {
			setText(initialText)
		} else {
			inputRef.current.focus()
			inputRef.current.select()
		}
	}, [])

	return (
		<PdfDraggableView onStop={onStop} onSubmit={() => onSubmit(text)} onClose={onClose}>
			<View css={style}>
				<input
					ref={inputRef}
					className="input"
					value={text}
					placeholder={'Text'}
					onChange={e => setText(e.target.value)}
				/>
			</View>
		</PdfDraggableView>
	)
}

const style = css({
	'.input': {
		border: 0,
		fontSize: 20,
		padding: 3,
		backgroundColor: 'rgba(0,0,0,0)',
		cursor: 'move',
	},
})
